import React from 'react';
import {ArrowUpRight} from 'lucide-react';
import './WeeklyDigestContent.css';

export default function WeeklyDigestContent({notification, teamName, onNavigate}) {
  const rows = (notification.payload?.digestRows || []).filter(row => typeof row.label === 'string' &&
    typeof row.url === 'string' && row.url.startsWith('/') && !row.url.startsWith('//'));
  const team = teamName || notification.teamName || notification.payload?.teamName;
  return <div className="weekly-digest">
    <strong>{team ? `[${team}] ` : ''}Weekly digest:</strong>
    <ul>{rows.map(row => <li key={row.key}>
      <span>{row.label}</span>
      <button type="button" className="weekly-digest__navigate" aria-label={`Open: ${row.label}`} title={`Open: ${row.label}`}
        onClick={event => {event.stopPropagation();onNavigate(row.url);}}><ArrowUpRight size={16} aria-hidden="true"/></button>
    </li>)}</ul>
  </div>;
}
